// **********************************************************
// Related News
// **********************************************************

const relatedNewsSlider = document.querySelectorAll('[data-slider="related-news"]');

const relatedNewsSliderOptions = {
  slidesPerView: 'auto',
  spaceBetween: 16,
  watchOverflow: true,
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  breakpoints: {
    767: {
      slidesPerView: 2,
      spaceBetween: 16,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  },
};

relatedNewsSlider.forEach((el) => new Swiper(el, relatedNewsSliderOptions));
